// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';
import {
  type SearchData,
  SearchFilterType,
  type SearchItem,
  type SearchRequestModel,
  type SerialSearchData,
  type WarrantyArticleSearchRequestModel,
} from './searchModels';

const modifyParams = (params: SearchRequestModel) => {
  return { ...params, bootstrapCol: 'lg' };
};
export const searchApi = createApi({
  reducerPath: 'searchApi',
  baseQuery: baseQuery('public', true),
  endpoints: (builder) => {
    return {
      search: builder.query<SearchData | SearchItem, SearchRequestModel>({
        query: (params) => {
          const { satc_mode, ...rest } = params;

          return {
            url: `${params.type ?? ''}/recherche`,
            method: 'get',
            params: modifyParams(satc_mode ? params : rest),
          };
        },
      }),
      searchAdvanced: builder.query<SearchData | SearchItem, SearchRequestModel>({
        query: (params) => {
          const { satc_mode, ...rest } = params;
          return {
            url: `recherche/avancee`,
            method: 'get',
            params: modifyParams(satc_mode ? params : rest),
          };
        },
      }),
      searchSerial: builder.query<SerialSearchData, SearchRequestModel>({
        query: (params) => {
          const { satc_mode, ...rest } = params;
          return {
            url: 'recherche/serie',
            method: 'get',
            params: modifyParams(satc_mode ? params : rest),
          };
        },
      }),
      searchWarrantyArticle: builder.query<SerialSearchData, WarrantyArticleSearchRequestModel>({
        query: (params) => {
          const { product_uuid, ...rest } = params;
          return {
            url: `${SearchFilterType.articles}/recherche/${product_uuid}`,
            method: 'get',
            params: rest,
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSearchQuery,
  useLazySearchQuery,
  usePrefetch,
  useSearchAdvancedQuery,
  useSearchSerialQuery,
  useLazySearchAdvancedQuery,
  useLazySearchSerialQuery,
  useLazySearchWarrantyArticleQuery,
} = searchApi;
